module.exports = __webpack_public_path__ + "img/ProcessImprovement1.d5d9dd31.jpg";